'use client'

import { useMemo } from 'react'
import Script from 'next/script'
import { userIsLoggedInSelector, useYotpoLoyaltyConfigQuery } from '@segway/core'
import { useAppSelector } from '@segway/core/src/store/hooks'

/**
 * YotpoWidget 插件
 */
const YotpoWidget = () => {
  const isLoggedIn = useAppSelector(userIsLoggedInSelector)

  const { data: loyaltyConfigData } = useYotpoLoyaltyConfigQuery(
    {},
    {
      skip: !isLoggedIn,
    },
  )

  const configData = useMemo(() => {
    if (loyaltyConfigData) {
      return loyaltyConfigData.yotpoSnippet
    }
  }, [loyaltyConfigData])

  return (
    <>
      {configData && configData.is_enabled ? (
        <>
          <div
            id="swell-customer-identification"
            style={{
              display: 'none !important',
            }}
            data-authenticated="true"
            data-email={configData.email}
            data-id={configData.id}
            data-token={configData.token}
            data-tags={`[${configData.snippet}]`}></div>
          <Script
            strategy="lazyOnload"
            src={`https://cdn-widgetsrepository.yotpo.com/v1/loader/${configData.guid}`}
          />
        </>
      ) : null}
    </>
  )
}

export default YotpoWidget
